<template>
  <div class="container-fluid">
    <div class="row mt-2">
      <div class="col-sm-9">
        <Info v-if="tabIndex == 0" @toggle-nav="showNav = !showNav" :priv="priv?.action"></Info>
      </div>
      <div class="col-sm-3">
        <Timeline></Timeline>
      </div>
    </div>
  </div>
</template>

<script>
import Info from './Components/Info/Main.vue'
import Timeline from './Components/Timeline/Main.vue'

export default {
  name: "Settings",
  components: {
    Info,
    Timeline
  },
  data() {
    return {
      showNav: true,
      tabIndex: 0,
      priv: []
    }
  },
  beforeMount() {
    this.priv = this.$route.meta.priv;
  }
};
</script>